import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Input } from 'ui-components/components/input';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import messages from '../messages';
import style from '../style.module.less';

const NameColumn = ({ categoryId, name, nameValue, setNameValue, idInEditMode = null, errorMessage = null }) => {
  return idInEditMode && categoryId === idInEditMode ? (
    <>
      <Input className={style.nameInput} hasError={!!errorMessage} maxLength={50} onChange={setNameValue} value={nameValue} />
      {errorMessage && (
        <Tooltip position='bottom'>
          <TooltipContent>
            <div className={style['tooltip-text']}>
              <FormattedMessage {...errorMessage} />
            </div>
          </TooltipContent>
          <div className={style['icon-wrapper']}>
            <FontAwesomeIcon className={style.icon} icon={faExclamationCircle} />
          </div>
        </Tooltip>
      )}
    </>
  ) : (
    name
  );
};

NameColumn.propTypes = {
  categoryId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  nameValue: PropTypes.string.isRequired,
  setNameValue: PropTypes.func.isRequired,
  idInEditMode: PropTypes.string,
  errorMessage: PropTypes.object,
};

export default {
  getMessageDescriptor: () => <FormattedMessage {...messages.nameColumn} />,
  id: 'name',
  sortBy: 'name',
  isSortable: true,
  render: NameColumn,
};
